import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ClosingSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#0D1B2A'
  }} data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-3">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-4" />

          <h2 className="text-2xl md:text-4xl font-bold mb-8 md:mb-12" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-5">
            Mot Final
          </h2>

          <div className="space-y-4 md:space-y-8 text-lg md:text-2xl leading-relaxed" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#C8C0B0'
        }} data-id="element-6">
            <p data-id="element-7">Sous la maman logistique,</p>
            <p className="font-bold" style={{
            color: '#D4A853'
          }} data-id="element-8">
              il y a une femme.
            </p>

            <p className="mt-6 md:mt-12" data-id="element-9">
              Qui mérite de s'asseoir le soir et d'être vraiment là.
            </p>
            <p data-id="element-10">Pas en train de planifier. Pas en train de s'inquiéter.</p>

            <p className="font-bold my-6 md:my-12" style={{
            color: '#F5F0E8'
          }} data-id="element-11">
              Juste là. Présente. Avec elle-même.
            </p>

            <p data-id="element-12">10 minutes ce soir.</p>
            <p data-id="element-13">Pour retrouver toutes tes soirées.</p>
            <p className="font-bold" style={{
            color: '#D4A853'
          }} data-id="element-14">
              Et te retrouver, toi.
            </p>
          </div>

          {/* Final CTA */}
          <div className="mt-10 md:mt-16 flex flex-col items-center gap-4 md:gap-6" data-id="element-15">
            <a href="https://redevenirmoi.com/cart/53294357643632:1" className="cta-pulse w-full max-w-lg inline-flex items-center justify-center gap-2 px-8 py-6 rounded-xl text-lg md:text-xl font-bold transition-transform hover:scale-105 active:scale-95" style={{
            background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
            color: '#0D1B2A',
            fontFamily: 'DM Sans, sans-serif',
            textDecoration: 'none'
          }} onClick={() => {
            if (typeof (window as any).fbq === 'function') {
              ;
              (window as any).fbq('track', 'AddToCart', {
                value: 9.97,
                currency: 'CAD',
                content_name: 'Le Signal OFF'
              });
            }
          }} data-id="element-16">
              👉 OUI, JE VEUX MON SILENCE MENTAL — 9,97 $
            </a>

            <div className="flex flex-col items-center gap-2 text-sm md:text-base font-medium" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-17">
              <p data-id="element-18">✅ Accès immédiat dès le paiement</p>
              <p data-id="element-19">✅ Guide complet + 2 Bonus inclus</p>
              <p data-id="element-20">✅ Garantie 30 jours ou remboursée</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}